// extracted by mini-css-extract-plugin
module.exports = {"container":"SavedSearchItem_container__nqIr5"};